export const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }
  return date.toLocaleDateString('en-US', options)
}

export const formatCurrency = (label: string) => label.split('-')[0]

export const getConfirmationUrl = (
  leftSideLabel: string,
  rightSideLabel: string
) => {
  const labels = [leftSideLabel, rightSideLabel]
  if (
    labels.some((label) =>
      ['USDT-BSC', 'BUSD-BSC', 'USDC-BSC', 'USDT-B', 'BUSD-B'].includes(label)
    )
  ) {
    return 'https://bscscan.com/'
  }
  if (
    labels.some((label) =>
      ['USDC-POLY', 'CADC-POLY', 'USDC-P', 'CADC-P'].includes(label)
    )
  ) {
    return 'https://polygonscan.com/'
  }
  if (labels.some((label) => ['USDC-ARB', 'CADC-ARB'].includes(label))) {
    return 'https://arbiscan.io/'
  }
  if (labels.includes('USDC-OP')) return 'https://optimistic.etherscan.io/'
  if (labels.includes('USDC-AVAX')) return 'https://snowtrace.io/'
  if (labels.includes('USDC-FTM')) return 'https://ftmscan.com/'
  if (labels.includes('USDC-GNO')) return 'https://gnosisscan.io/'
  if (labels.includes('USDC-CELO')) return 'https://celoscan.io/'
  if (labels.includes('USDC-SX')) return 'https://explorer.sx.technology/'
  if (labels.some((label) => ['USDC-BASE', 'CADC-BASE'].includes(label))) {
    return 'https://basescan.org/'
  }
  if (labels.some((label) => ['USDC-SOL', 'CADC-SOL'].includes(label))) {
    return 'https://solscan.io/'
  }
  return 'https://etherscan.io/'
}

export const getNetwork = (
  leftSideLabel: string,
  rightSideLabel: string,
  t: (key: string) => string
) => {
  const labels = [leftSideLabel, rightSideLabel]
  if (
    labels.some((label) =>
      ['USDT-BSC', 'BUSD-BSC', 'USDC-BSC', 'USDT-B', 'BUSD-B'].includes(label)
    )
  ) {
    return t('transactionRows.networks.binanceSmartChain')
  }
  if (
    labels.some((label) =>
      ['USDC-POLY', 'CADC-POLY', 'USDC-P', 'CADC-P'].includes(label)
    )
  ) {
    return 'Polygon'
  }
  if (labels.some((label) => ['USDC-ARB', 'CADC-ARB'].includes(label))) {
    return 'Arbitrum'
  }
  if (labels.includes('USDC-OP')) return 'Optimism'
  if (labels.includes('USDC-AVAX')) return 'Avalanche'
  if (labels.includes('USDC-FTM')) return 'Fantom'
  if (labels.includes('USDC-GNO')) return 'Gnosis'
  if (labels.includes('USDC-CELO')) return 'Celo'
  if (labels.includes('USDC-SX')) return 'SX Network'
  if (labels.some((label) => ['USDC-BASE', 'CADC-BASE'].includes(label))) {
    return 'Base'
  }
  if (labels.some((label) => ['USDC-SOL', 'CADC-SOL'].includes(label))) {
    return 'Solana'
  }
  if (labels.some((label) => ['USDC-ETH', 'CADC-ETH'].includes(label))) {
    return 'Ethereum'
  }
  return 'Ethereum'
}
